/**
 * Created by draplater on 17-7-13.
 */

import {baseDir} from "../utils";
import {groupByPattern} from '../tagUtils';
import * as React from 'react';
import {Breadcrumb, Table, Form, Radio, Panel} from 'react-bootstrap';
import {Actions, GlobalState, store} from "../reduxSetting";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import * as _ from "underscore";
import {renderPath} from "./utils";
import CompareFunc = SentenceViewer.CompareFunc;
import {MenuManagerWrapperRedux} from "../Menu";
import {
    FrameInfo, FrameMeta, SemiLexicalizedCollocates, Tag, ColorMapType,
    defaultColorMap
} from "../problem-domain/frame";
import {Sentence, Span, Verb} from "../problem-domain/verb";
import * as DocumentTitle from 'react-document-title';
import {FrameInfoWire, VerbWire} from "../bridge";
import {ComparePopupSelect} from "./compare-popup";
import {RouteComponentProps, withRouter} from "react-router";


interface SentenceGroupProps {
    pattern: string[],
    sentences: Span[][],
    colorMap: ColorMapType,
    totalCount?: number,
    percentage?: number,
    hideCount?: boolean,
    expanded?: boolean,
    show_all?: boolean,
    customTitle?: JSX.Element
}

export class SentenceGroup extends React.Component<SentenceGroupProps, { expanded: boolean, show_all: boolean }> {
    public static defaultProps: Partial<SentenceGroupProps> = {
        expanded: true,
        show_all: false
    };

    constructor(props: SentenceGroupProps) {
        super(props);
        this.state = {
            expanded: this.props.expanded!,
            show_all: this.props.show_all!
        };
    }

    componentWillReceiveProps(nextProp: SentenceGroupProps) {
        this.setState({expanded: true});
    }

    toggle(): void {
        this.setState({expanded: !this.state.expanded});
    }

    renderPattern(showCount = true, customTitlePart: JSX.Element | undefined = undefined): JSX.Element {
        const totalCount = this.props.totalCount ? this.props.totalCount : this.props.sentences.length;
        return (<div className="pattern-title">
            <span>Pattern: &nbsp;</span>
            {this.props.pattern.map(frame =>
                <span className="pattern-frame"
                      style={{backgroundColor: this.props.colorMap(frame)}}>[{frame}]
                </span>)}
            {showCount && <span>&nbsp;({totalCount} sentence{totalCount > 1 ? "s" : ""}
                {this.props.percentage && `, ${(this.props.percentage * 100).toFixed(1)}% of all`}
                )</span>}
            {customTitlePart}
        </div>);
    }

    static renderParsedSentence(sentence: Span[], colorMap: ColorMapType): JSX.Element {
        return (
            <li>
                {
                    sentence.map((span) => {
                        if (!span.role) {
                            return span.text;
                        } else {
                            return (
                                <div className="with-role" style={{backgroundColor: colorMap(span.role)}}>
                                    <div className="lexicon-with-frame">
                                        {span.text}</div>
                                    <div className="role"> {span.role}</div>
                                </div>);
                        }
                    })
                }
            </li>
        )
    }

    renderSentences() {
        let sentences = this.props.sentences;
        if (!this.state.show_all) {
            sentences = sentences.slice(0, 3);
        }
        return (<ul className="grouped-sentences"
                    style={{display: this.state.expanded ? "block" : "none"}}>
            {sentences.map(
                sentence => SentenceGroup.renderParsedSentence(sentence, this.props.colorMap))}
            {(this.props.sentences.length > 3 && !this.state.show_all) ?
                <li>
                    <a onClick={() => {
                        this.setState({show_all: true})
                    }} className="sentence-group-show-more">
                        show all sentences...({this.props.sentences.length - 3} rest)
                    </a></li> : null}
        </ul>);
    }

    render(): JSX.Element {
        return (
            <div className="sentence-group">
                <h4 className="pattern-title">
                    <span className="tree-indicator unselectable"
                          onClick={this.toggle.bind(this)}>
                        {this.state.expanded ? "▼" : "►"}
                    </span> {this.renderPattern(!this.props.hideCount, this.props.customTitle)} </h4>
                {this.renderSentences()}
            </div>
        );
    }
}


namespace SentenceViewer {
    export interface Props {
        sentences: Sentence[];
        colorMap: ColorMapType;
    }

    export type CompareFunc = (a: [string, Span[][]], b: [string, Span[][]]) => number;

    export interface State {
        cmp: CompareFunc;
    }
}

export const cmpByCount: CompareFunc = (a, b) => b[1].length - a[1].length;
export const cmpByName: CompareFunc = (a, b) => a[0].localeCompare(b[0]);

export class SentenceViewer extends React.Component<SentenceViewer.Props,
    SentenceViewer.State> {
    constructor(props) {
        super(props);
        this.state = {cmp: cmpByCount};
    }

    render(): JSX.Element {
        const sentences_grouped = groupByPattern(this.props.sentences);
        return <div className="sentences-groups">
            <div>
                <div style={{float: "right"}}>
                    <Form>
                        <Radio name="order"
                               onClick={() => this.setState({cmp: cmpByCount})}
                               checked={this.state.cmp == cmpByCount}> Order by Count </Radio>
                        <Radio name="order"
                               onClick={() => this.setState({cmp: cmpByName})}
                               checked={this.state.cmp == cmpByName}> Order by Pattern </Radio>
                    </Form>
                </div>
                <h2 style={{display: "inline-block"}}>
                    Annotations ({this.props.sentences.length} sentences)</h2>
            </div>
            <div className="sentences-list">
                {Array.from(sentences_grouped.entries())
                    .sort(this.state.cmp)
                    .map(
                        ([pattern, sentences]) =>
                            <SentenceGroup pattern={pattern.split(",")}
                                           sentences={sentences}
                                           colorMap={this.props.colorMap}
                                           percentage={sentences.length / this.props.sentences.length}
                            />)}
            </div>
        </div>;
    }
}

export interface LexiconProps extends RouteComponentProps<any> {
    frameIndex: FrameMeta;
    data: CurrentLexiconData;
}

interface TagNameWithCount {
    name: string;
    count: number;
}

export class LexiconPage extends React.Component<LexiconProps, {}> {
    renderBreadcrumb(): JSX.Element {
        const lexiconName = this.props.data.path.slice(-1)[0];
        let BreadcrumbItem: any = Breadcrumb.Item;
        return (
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link to="/"> VerbNet </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link to="/verb-index"> Verbs </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link to={"/lexicon/" + this.props.data.path.join("/")}>
                        {lexiconName} </Link>
                </BreadcrumbItem>
            </Breadcrumb>
        );
    }

    static tagStatistics(examples: Span[][]): TagNameWithCount[] {
        const tags: string[] = _.flatten(examples)
            .map(span => span.role)
            .filter(x => x !== undefined);
        const countMap = _.countBy(tags, x => x);
        return _.map(countMap, (num, key) => {
            return {name: key, count: num};
        }).sort((a, b) => b.count - a.count);
    }

    static renderTagRow(definition: string, name: string, count: number,
                        color: string | undefined): JSX.Element {
        return <tr>
            <td><span
                style={{backgroundColor: color}}>
                {name}</span></td>
            <td>{definition}</td>
            <td>{count}</td>
        </tr>;
    }

    static renderTagSets(tags: Tag[], colorMap: ColorMapType,
                         counter: TagNameWithCount[],
                         semiLexicalized: Map<string, SemiLexicalizedCollocates>,
                         title: string = "FE"): JSX.Element {
        const tagsMap = new Map<string, Tag>(tags.map(
            tag => [tag.name, tag] as [string, Tag]));

        return (
            <div className="tag-info">
                <Table striped bordered condensed hover>
                    <thead>
                    <tr>
                        <th>{title}</th>
                        <th>Definition</th>
                        <th>Count</th>
                    </tr>
                    </thead>
                    <tbody>
                    {counter.map(({name, count}) => {
                            const tag = tagsMap.get(name);
                            let definition = "";
                            if (tag) {
                                definition = tag.definition;
                            } else {
                                const semil = semiLexicalized.get(name);
                                if (semil) {
                                    definition = "Semi-Lexicalized Collocates: " + semil.name;
                                }
                            }
                            return LexiconPage.renderTagRow(
                                definition, name, count, colorMap(name))
                        }
                    )}
                    </tbody>
                </Table>
            </div>
        );
    }

    render(): JSX.Element {
        const lexiconName = this.props.data.path.slice(-1)[0];
        const lastFrame = this.props.data.frameChain.slice(-1)[0];
        const tags = this.props.data.frameChain.length ? lastFrame.getCombinedTags() : [];
        const colorMap = this.props.data.frameChain.length ? lastFrame.getColorMap() : defaultColorMap;
        const semiLexicalisedByName = new Map();
        if (this.props.data.frameChain.length)
            Array.from(this.props.data.frameChain.slice(-1)[0].semiLexicalized.values())
                .forEach(x => semiLexicalisedByName.set(x.tag, x));
        return (
            <div className="lexicon-info">
                {this.renderBreadcrumb()}
                <h1> {lexiconName} {this.props.data.verb.pinyin || ""} </h1>
                <ComparePopupSelect frameIndex={this.props.frameIndex} currentLexicon={this.props.data}
                                    style={{"float": "right"}}
                                    history={this.props.history}
                />
                <h2> Frame</h2>
                <p> {renderPath(this.props.data.path, this.props.frameIndex, true)} </p>
                <h2> Frame Elements </h2>
                <div className="roles-list">
                    {LexiconPage.renderTagSets(tags, colorMap,
                        LexiconPage.tagStatistics(this.props.data.verb.sentences).filter(
                            x => x.name !== this.props.data.path.slice(-2)[0]
                                && !x.name.startsWith("*")),
                        semiLexicalisedByName)}
                </div>
                <h2> Constructional Markers </h2>
                <div className="roles-list">
                    {LexiconPage.renderTagSets(tags, colorMap,
                        LexiconPage.tagStatistics(this.props.data.verb.sentences).filter(
                            x => x.name !== this.props.data.path.slice(-2)[0]
                                && x.name.startsWith("*")),
                        semiLexicalisedByName, "Marker")}
                </div>
                <SentenceViewer sentences={this.props.data.verb.sentences} colorMap={colorMap}/>
            </div>
        )
    }
}

interface LexiconPageManagedProps extends RouteComponentProps<any> {
    frameIndex?: FrameMeta,
    path: string[]
}

export interface CurrentLexiconData {
    verb: Verb;
    frameChain: FrameInfo[];
    path: string[];
}

export class LexiconPageManaged extends React.Component<LexiconPageManagedProps,
    { data?: CurrentLexiconData, pending: boolean }> {
    constructor(props: LexiconPageManagedProps) {
        super(props);
        this.state = {pending: false};
    }

    componentDidMount() {
        this.getLexicon(this.props);
    }

    componentWillReceiveProps(newProps) {
        this.getLexicon(newProps);
    }

    componentWillUnmount() {
        this.setState({data: undefined});
    }

    async getLexicon(props: LexiconPageManagedProps) {
        if (!props.frameIndex) {
            return;
        }

        this.setState({pending: true});

        let parentFrameInfo: FrameInfo | undefined = undefined;
        const parentFrameMeta = props.frameIndex.find(props.path.slice(0, -1));
        if (parentFrameMeta && parentFrameMeta.def) {
            parentFrameInfo = await FrameInfoWire.get(props.path.slice(0, -1),
                parentFrameMeta.def);
        }

        // only parent frame is needed now
        // but we use array there in case we want to use grand parent frame in future
        const frameChain = parentFrameInfo ? [parentFrameInfo] : [];
        this.setState({
            data: {
                verb: await VerbWire.get(this.props.path),
                frameChain, path: props.path
            },
            pending: false
        })
    }

    render() {
        const LexiconPageRouted = withRouter(LexiconPage) as any;
        if (this.props.frameIndex) {
            if (this.state.data) {
                return <div className="main-panel">
                    {(this.state.pending) &&
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        textAlign: "center",
                    }}><span>Loading Frame...</span></div>}
                    <div style={{opacity: this.state.pending ? 0.4 : 1}}>
                        <LexiconPageRouted frameIndex={this.props.frameIndex} data={this.state.data}/>
                    </div>
                </div>
            } else {
                return <div className="main-panel"> Loading Verb...</div>;
            }
        } else {
            return <div className="main-panel"> Loading Frame Index...</div>;
        }
    }
}

export const LexiconPageManagedRedux = connect(
    (state: GlobalState, ownProps: { path: string[] }): any => {
        return {
            frameIndex: state.index.frames.length ? FrameMeta.wrapTop(state.index.frames) : undefined,
            path: ownProps.path
        };
    },
    dispatch => ({})
)(LexiconPageManaged as any);

export function renderLexiconPageWithRoute({location}) {
    window.scrollTo(0, 0);
    const path: string[] = location.pathname.replace("/lexicon/", "").split("/");

    return <DocumentTitle title={`${path.slice(-1)[0]} - Verb - Mandarin VerbNet`}>
        <MenuManagerWrapperRedux>
            <Panel><LexiconPageManagedRedux path={path}/></Panel>
        </MenuManagerWrapperRedux>
    </DocumentTitle>;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LexiconPage.tsx